import { object, string, number, boolean, date } from 'yup';
import { MILESTONE_TYPES, MILESTONE_STATUSES } from './milestone.constants';


const milestoneSchema = object({
  id: string(),
  company_id: string(),
  created_on: date().required(),
  updated_on: date().required(),
  deal_id: string().nullable().default(null),
  name: string().required(),
  type: string().oneOf(Object.values(MILESTONE_TYPES)).nullable(),
  status: string().oneOf(Object.values(MILESTONE_STATUSES)).required(),
  due_in_days: number().integer().nullable(), // no due date when due_in_days is null
  due_relative_date: string().nullable(),
  is_after_action: boolean().default(true),
  editable: boolean().required(),
});

export default milestoneSchema;
